import React from 'react';
import {
    StyleSheet,
    View,
} from 'react-native';
import Video from 'react-native-video';
import { Telemetry } from 'app/services/telemetry/Telemetry';

interface IVideoViewerProps {
    videoUrl: string;
    style?: any;
    resizeMode?: 'contain' | 'cover' | 'stretch';
    controls?: boolean;
    paused?: boolean;
    repeat?: boolean;
}

export const VideoViewer: React.FC<IVideoViewerProps> = ({
    videoUrl,
    style,
    resizeMode = 'contain',
    controls = true,
    paused = false,
    repeat = false,
}) => {
    const handleError = (error: any) => {
        Telemetry.error(error, {
            event: 'ui.video.playback_error',
            domain: 'ui',
            context: { source: 'VideoViewer', videoUrl }
        });
    };
    return (
        <View style={[styles.container, style]}>
            <Video
                source={{ uri: videoUrl }}
                style={styles.video}
                resizeMode={resizeMode}
                controls={controls}
                paused={paused}
                repeat={repeat}
                onError={handleError}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#000',
    },
    video: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
});
